export enum Breakpoint {
  Game = 'gm',
  Tablet = 'xs',
  Mobile = 'none',
}
